
/**
 * Send a form details to the sendmail.php file.
 */

+function($){

  page.initMailer = function() {

    var validEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    $('[data-form="mailer"]').each(function(){

      var form      = $(this),
          email     = form.find('[name="email"]'),
          onSuccess = form.dataAttr('on-success', null),
          onError   = form.dataAttr('on-error', null);

      form.on('submit', function(){


        form.children('.alert-danger').remove();
        form.children('.alert-success').hide();


          var hasEmptyField = false;
          form.find('[required]').each(function () {
              if ( $(this).val().length < 1 ) {
                  $(this).addClass('is-invalid');
                  hasEmptyField = true;
                  return false;
              }
          });

          if(hasEmptyField){
            return false;
          }

          if ( email.length ) {
            if ( email.val().length < 1 || ! validEmail.test( email.val() ) ) {
              email.addClass('is-invalid');
              return false;
            }
          }

        $.ajax({
          type: "POST",
          url: form.attr('action'),
          data: form.serializeArray(),
        })
        .done( function( data ) {
          var response = $.parseJSON( data );
          if ( 'success' == response.status ) {
            form.find('.alert-success').fadeIn(1000);
            form.find(':input').val('');
            if ( onSuccess !== null ) {
              window[onSuccess]();
            }
          }
          else {
            form.prepend('<div class="col-12 alert alert-danger">'+ response.message +'</div>');
            console.log( response.reason );
            if ( onError !== null ) {
              window[onError](response.reason);
            }
          }
        });

        return false;
      });

      email.on('focus', function() {
        $(this).removeClass('is-invalid');
      });

      form.find('[required]').on('focus', function() {
        $(this).removeClass('is-invalid');
      });

    });

  }

}(jQuery);

